import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API, useAuth } from '../../context/AuthContext';
import { useTheme } from '../../context/ThemeContext';
import { Plus, Trash2, X, Save, Sparkles } from 'lucide-react';

export default function ManageAffirmations() {
  const { token } = useAuth();
  const { currentColors } = useTheme();
  const [affirmations, setAffirmations] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({ text: '', category: '' });

  useEffect(() => { loadAffirmations(); }, []);

  const loadAffirmations = async () => {
    try {
      const response = await axios.get(`${API}/affirmations`);
      setAffirmations(response.data);
    } catch (error) { console.error('Failed to load affirmations:', error); }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API}/affirmations`, formData, { headers: { Authorization: `Bearer ${token}` } });
      setFormData({ text: '', category: '' });
      setShowForm(false);
      loadAffirmations();
    } catch (error) { alert('Failed to create affirmation'); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this affirmation?')) return;
    try {
      await axios.delete(`${API}/affirmations/${id}`, { headers: { Authorization: `Bearer ${token}` } });
      loadAffirmations();
    } catch (error) { alert('Failed to delete'); }
  };

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div className="flex items-center gap-3">
          <Sparkles className="w-6 h-6" style={{ color: currentColors.primary }} />
          <h2 className="text-2xl font-cinzel" style={{ color: currentColors.primary }}>Manage Affirmations</h2>
        </div>
        <button onClick={() => setShowForm(!showForm)} className="cosmic-btn flex items-center gap-2">
          {showForm ? <X className="w-5 h-5" /> : <Plus className="w-5 h-5" />}
          <span>{showForm ? 'Cancel' : 'Add New'}</span>
        </button>
      </div>

      {showForm && (
        <div className="glass-card p-6">
          <h3 className="text-xl font-cinzel mb-4" style={{ color: currentColors.text }}>Add Affirmation</h3>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm mb-1" style={{ color: currentColors.textMuted }}>Affirmation Text *</label>
              <textarea value={formData.text} onChange={(e) => setFormData({ ...formData, text: e.target.value })} className="cosmic-input w-full" rows="3" required />
            </div>
            <div>
              <label className="block text-sm mb-1" style={{ color: currentColors.textMuted }}>Category *</label>
              <input type="text" value={formData.category} onChange={(e) => setFormData({ ...formData, category: e.target.value })} className="cosmic-input w-full" placeholder="e.g., Self-Love, Abundance, Healing" required />
            </div>
            <button type="submit" className="cosmic-btn w-full flex items-center justify-center gap-2">
              <Save className="w-5 h-5" /><span>Create Affirmation</span>
            </button>
          </form>
        </div>
      )}

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {affirmations.map((aff) => (
          <div key={aff.id} className="glass-card p-4">
            <p className="italic text-lg mb-3" style={{ color: currentColors.text }}>"{aff.text}"</p>
            <div className="flex items-center justify-between">
              <span className="text-xs px-2 py-1 rounded-full" style={{ backgroundColor: `${currentColors.secondary}20`, color: currentColors.secondary }}>{aff.category}</span>
              <button onClick={() => handleDelete(aff.id)} className="p-2 rounded-lg text-red-400 hover:bg-red-500/10"><Trash2 className="w-4 h-4" /></button>
            </div>
          </div>
        ))}
        {affirmations.length === 0 && (
          <div className="col-span-full text-center py-8" style={{ color: currentColors.textMuted }}>No affirmations found.</div>
        )}
      </div>
    </div>
  );
}
